import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewChild, Input, Output, ContentChildren, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@angular/forms';
import { NgControl, NgModel, FormsModule } from '@angular/forms';
import * as i1 from '@capturum/ui/api';
import { ValueAccessorBase, CapturumTemplateDirective, CapturumSharedModule } from '@capturum/ui/api';
import * as i4 from 'primeng/dropdown';
import { Dropdown, DropdownModule } from 'primeng/dropdown';
import * as i5 from 'primeng/api';
import { OverlayPanelModule } from 'primeng/overlaypanel';
function CapturumDropdownComponent_label_1_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r15.label);
  }
}
const _c0 = function (a0) {
  return {
    "justify-content": a0
  };
};
function CapturumDropdownComponent_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵtemplate(1, CapturumDropdownComponent_label_1_span_1_Template, 2, 1, "span", 10);
    i0.ɵɵprojection(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(3, _c0, ctx_r0.label ? "space-between" : "flex-end"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.label);
  }
}
function CapturumDropdownComponent_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CapturumDropdownComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CapturumDropdownComponent_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r4);
  }
}
function CapturumDropdownComponent_ng_template_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CapturumDropdownComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtemplate(1, CapturumDropdownComponent_ng_template_3_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementStart(2, "label", 13);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.label);
  }
}
const _c1 = function (a0) {
  return {
    $implicit: a0
  };
};
function CapturumDropdownComponent_ng_template_5_ng_container_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 16);
  }
  if (rf & 2) {
    const item_r22 = ctx.$implicit;
    const ctx_r21 = i0.ɵɵnextContext(3);
    const _r10 = i0.ɵɵreference(12);
    const _r12 = i0.ɵɵreference(14);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r21.itemTemplate || ctx_r21.withImages && _r10 || ctx_r21.withIcons && _r12)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c1, item_r22));
  }
}
function CapturumDropdownComponent_ng_template_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CapturumDropdownComponent_ng_template_5_ng_container_1_ng_template_1_Template, 1, 4, "ng-template", 15);
    i0.ɵɵelementContainerEnd();
  }
}
function CapturumDropdownComponent_ng_template_5_ng_container_2_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 16);
  }
  if (rf & 2) {
    const item_r24 = ctx.$implicit;
    i0.ɵɵnextContext(3);
    const _r8 = i0.ɵɵreference(10);
    i0.ɵɵproperty("ngTemplateOutlet", _r8)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c1, item_r24));
  }
}
function CapturumDropdownComponent_ng_template_5_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CapturumDropdownComponent_ng_template_5_ng_container_2_ng_template_1_Template, 1, 4, "ng-template", 17);
    i0.ɵɵelementContainerEnd();
  }
}
function CapturumDropdownComponent_ng_template_5_ng_container_3_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 16);
  }
  if (rf & 2) {
    const item_r26 = ctx.$implicit;
    const ctx_r25 = i0.ɵɵnextContext(3);
    const _r6 = i0.ɵɵreference(8);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r25.selectedItcapTemplate ? ctx_r25.selectedItcapTemplate : _r6)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c1, item_r26));
  }
}
function CapturumDropdownComponent_ng_template_5_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CapturumDropdownComponent_ng_template_5_ng_container_3_ng_template_1_Template, 1, 4, "ng-template", 17);
    i0.ɵɵelementContainerEnd();
  }
}
function CapturumDropdownComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-dropdown", 14);
    i0.ɵɵlistener("onChange", function CapturumDropdownComponent_ng_template_5_Template_p_dropdown_onChange_0_listener($event) {
      i0.ɵɵrestoreView(_r28);
      const ctx_r27 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r27.onChangeEvent($event));
    })("onBlur", function CapturumDropdownComponent_ng_template_5_Template_p_dropdown_onBlur_0_listener($event) {
      i0.ɵɵrestoreView(_r28);
      const ctx_r29 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r29.onBlur($event));
    })("onFocus", function CapturumDropdownComponent_ng_template_5_Template_p_dropdown_onFocus_0_listener($event) {
      i0.ɵɵrestoreView(_r28);
      const ctx_r30 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r30.onFocus($event));
    })("onClick", function CapturumDropdownComponent_ng_template_5_Template_p_dropdown_onClick_0_listener($event) {
      i0.ɵɵrestoreView(_r28);
      const ctx_r31 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r31.onClick($event));
    })("onHide", function CapturumDropdownComponent_ng_template_5_Template_p_dropdown_onHide_0_listener($event) {
      i0.ɵɵrestoreView(_r28);
      const ctx_r32 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r32.hide.emit($event));
    })("onShow", function CapturumDropdownComponent_ng_template_5_Template_p_dropdown_onShow_0_listener($event) {
      i0.ɵɵrestoreView(_r28);
      const ctx_r33 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r33.show.emit($event));
    })("focus", function CapturumDropdownComponent_ng_template_5_Template_p_dropdown_focus_0_listener($event) {
      i0.ɵɵrestoreView(_r28);
      const ctx_r34 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r34.onFocus($event));
    })("ngModelChange", function CapturumDropdownComponent_ng_template_5_Template_p_dropdown_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r28);
      const ctx_r35 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r35.value = $event);
    });
    i0.ɵɵtemplate(1, CapturumDropdownComponent_ng_template_5_ng_container_1_Template, 2, 0, "ng-container", 10);
    i0.ɵɵtemplate(2, CapturumDropdownComponent_ng_template_5_ng_container_2_Template, 2, 0, "ng-container", 10);
    i0.ɵɵtemplate(3, CapturumDropdownComponent_ng_template_5_ng_container_3_Template, 2, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(ctx_r5.style);
    i0.ɵɵclassProp("readonly", ctx_r5.readonly);
    i0.ɵɵproperty("ngModel", ctx_r5.value)("appendTo", ctx_r5.appendTo)("filterBy", ctx_r5.filterBy)("filterPlaceholder", ctx_r5.filterPlaceholder)("autoDisplayFirst", ctx_r5.autoDisplayFirst)("filter", ctx_r5.filter)("optionLabel", ctx_r5.optionLabel)("options", ctx_r5.options)("panelStyleClass", "cap-dropdown-panel " + ctx_r5.panelStyleClass)("panelStyle", ctx_r5.panelStyle)("editable", ctx_r5.editable)("placeholder", ctx_r5.placeholder)("scrollHeight", ctx_r5.scrollHeight)("resetFilterOnHide", ctx_r5.resetFilterOnHide)("showClear", ctx_r5.showClear)("group", ctx_r5.group)("styleClass", "cap-dropdown " + ctx_r5.styleClass)("virtualScroll", ctx_r5.virtualScroll)("virtualScrollItemSize", ctx_r5.virtualScrollItemSize)("disabled", ctx_r5.disabled)("dropdownIcon", ctx_r5.dropdownIcon)("readonly", ctx_r5.readonly)("optionValue", ctx_r5.optionValue)("tabindex", ctx_r5.tabindex)("autofocus", ctx_r5.autofocus)("autofocusFilter", ctx_r5.autofocusFilter);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.itemTemplate || ctx_r5.withImages || ctx_r5.withIcons);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.withIcons);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.selectedItcapTemplate || ctx_r5.withImages);
  }
}
function CapturumDropdownComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelement(1, "img", 19);
    i0.ɵɵelementStart(2, "span", 20);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r36 = ctx.$implicit;
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", item_r36 == null ? null : item_r36.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r7.customLabelProperty ? item_r36[ctx_r7.customLabelProperty] : item_r36 == null ? null : item_r36.label);
  }
}
const _c2 = function (a0) {
  return [a0, "selected-icon"];
};
function CapturumDropdownComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelement(1, "i", 21);
    i0.ɵɵelementStart(2, "span", 22);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r37 = ctx.$implicit;
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c2, item_r37 == null ? null : item_r37.icon));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r9.customLabelProperty ? item_r37[ctx_r9.customLabelProperty] : item_r37 == null ? null : item_r37.label);
  }
}
function CapturumDropdownComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelement(1, "img", 24);
    i0.ɵɵelementStart(2, "div", 25);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r38 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", item_r38 == null ? null : item_r38.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r38 == null ? null : item_r38.label);
  }
}
const _c3 = function (a0) {
  return [a0, "item-icon"];
};
function CapturumDropdownComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelement(1, "i", 21);
    i0.ɵɵelementStart(2, "span", 27);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r39 = ctx.$implicit;
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c3, (item_r39 == null ? null : item_r39.icon) || ""));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r13.customLabelProperty ? item_r39[ctx_r13.customLabelProperty] : item_r39 == null ? null : item_r39.label);
  }
}
function CapturumDropdownComponent_cap_validator_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cap-validator", 28);
  }
  if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r14.control)("customName", ctx_r14.label);
  }
}
const _c4 = [[["", 8, "tooltip-content"]]];
const _c5 = [".tooltip-content"];
let CapturumDropdownComponent = /*#__PURE__*/(() => {
  class CapturumDropdownComponent extends ValueAccessorBase {
    constructor(injector, validatorService) {
      super();
      this.injector = injector;
      this.validatorService = validatorService;
      /**
       * Sort the dropdown options alphabetically
       */
      this.sortAlphabetically = true;
      /**
       * Define the property it should sort by
       */
      this.sortBy = 'label';
      /**
       * Height of the viewport in pixels, a scrollbar is defined if height of list exceeds this value
       */
      this.scrollHeight = '200px';
      /**
       * Name of the input element
       */
      this.name = '';
      /**
       * Style class of the element
       */
      this.styleClass = '';
      /**
       * Style class of the overlay panel element
       */
      this.panelStyleClass = '';
      /**
       * Default text to display when no option is selected
       */
      this.placeholder = '';
      /**
       * Placeholder text to show when filter input is empty
       */
      this.filterPlaceholder = '';
      /**
       * Identifier of the accessible input element
       */
      this.inputId = '';
      /**
       * Identifier of the native element
       */
      this.selectId = '';
      /**
       * A property to uniquely identify a value in options
       */
      this.dataKey = '';
      /**
       * When filtering is enabled, filterBy decides which field or fields (comma separated) to search against
       */
      this.filterBy = 'label';
      /**
       * Clears the filter value when hiding the dropdown
       */
      this.resetFilterOnHide = false;
      /**
       * Icon class of the dropdown icon
       */
      this.dropdownIcon = 'pi pi-chevron-down';
      /**
       * Name of the label field of an option when an arbitrary objects instead of SelectItems are used as options
       */
      this.optionLabel = '';
      /**
       * Whether to display the first item as the label if no placeholder is defined and value is null
       */
      this.autoDisplayFirst = true;
      /**
       * Text to display when filtering does not return any results
       */
      this.emptyFilterMessage = 'No results found';
      /**
       * Whether to use virtual scroll
       */
      this.virtualScroll = false;
      /**
       * Height of an item in the list
       */
      this.virtualScrollItemSize = 30;
      /**
       * Whether to automatically manage layering
       */
      this.autoZIndex = true;
      /**
       * Base zIndex value to use in layering
       */
      this.baseZIndex = 0;
      /**
       * Transition options of the show animations
       */
      this.showTransitionOptions = '225ms ease-out';
      /**
       * Transition options of the hide animation
       */
      this.hideTransitionOptions = '195ms ease-in';
      /**
       * Defines a string that labels the filter input
       */
      this.ariaFilterLabel = '';
      /**
       * When present, it specifies that the component should be disabled
       */
      this.disabled = false;
      /**
       * Open the dropdown on focus
       */
      this.openOnFocus = false;
      /**
       * Name of the value field of an option.
       */
      this.optionValue = 'value';
      /**
       * Applies focus to the filter element when the overlay is shown.
       */
      this.autofocusFilter = true;
      /**
       * Float label
       */
      this.floatLabel = false;
      /**
       * Display Icon
       */
      this.withIcons = false;
      /**
       * Callback to invoke when value of dropdown changes
       *
       * @deprecated use changeSelection instead
       */
      this.change = new EventEmitter();
      /**
       * Callback to invoke when value of dropdown changes
       */
      this.changeSelection = new EventEmitter();
      /**
       * Callback to invoke when dropdown gets focus
       */
      this.focus = new EventEmitter();
      /**
       * Callback to invoke when dropdown loses focus.
       */
      this.blur = new EventEmitter();
      /**
       * Callback to invoke when component is clicked
       */
      this.click = new EventEmitter();
      /**
       * Callback to invoke when dropdown overlay gets visible.
       */
      this.show = new EventEmitter();
      /**
       * Callback to invoke when dropdown overlay gets hidden
       */
      this.hide = new EventEmitter();
      this.clicked = false;
    }
    /**
     * Listen for changes to the sort variables, needed to make sure the sorting is done correctly..
     */
    ngOnChanges({
      sortBy
    }) {
      if (this.options && this.sortAlphabetically !== false) {
        this.options = this.sort(this.options);
      }
    }
    ngAfterViewInit() {
      setTimeout(() => {
        const ngControl = this.injector.get(NgControl, null);
        this.control = this.validatorService.extractFormControl(ngControl);
      });
    }
    /**
     * switch templates based on the content children
     */
    ngAfterContentInit() {
      this.templates.forEach(template => {
        switch (template.getType()) {
          case 'item':
            this.itemTemplate = template.template;
            break;
          case 'selectedItem':
            this.selectedItcapTemplate = template.template;
            break;
        }
      });
    }
    sort(value) {
      return value.sort((a, b) => {
        // If sortAlphabetically is selected, do a LowerCase() and otherwise leave it for numeric
        const valueA = typeof a[this.sortBy] === 'string' && this.sortAlphabetically ? a[this.sortBy].toLowerCase() : a[this.sortBy];
        const valueB = typeof b[this.sortBy] === 'string' && this.sortAlphabetically ? b[this.sortBy].toLowerCase() : b[this.sortBy];
        return valueA > valueB ? 1 : -1;
      });
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    onChangeEvent($event) {
      this.touch();
      this.change.emit($event);
      this.changeSelection.emit($event);
    }
    onBlur($event) {
      this.clicked = false;
      this.touch();
      this.blur.emit();
    }
    onFocus(event) {
      if (this.openOnFocus && !this.clicked) {
        this.dropdown.overlayVisible = true;
      }
      this.focus.emit(event);
    }
    onClick($event) {
      this.clicked = true;
      this.click.emit($event);
    }
    static {
      this.ɵfac = function CapturumDropdownComponent_Factory(t) {
        return new (t || CapturumDropdownComponent)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1.ValidatorService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumDropdownComponent,
        selectors: [["cap-dropdown"]],
        contentQueries: function CapturumDropdownComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, CapturumTemplateDirective, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
          }
        },
        viewQuery: function CapturumDropdownComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(NgModel, 7);
            i0.ɵɵviewQuery(Dropdown, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.model = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
          }
        },
        inputs: {
          label: "label",
          options: "options",
          sortAlphabetically: "sortAlphabetically",
          sortBy: "sortBy",
          scrollHeight: "scrollHeight",
          filter: "filter",
          name: "name",
          style: "style",
          panelStyle: "panelStyle",
          styleClass: "styleClass",
          panelStyleClass: "panelStyleClass",
          readonly: "readonly",
          required: "required",
          editable: "editable",
          appendTo: "appendTo",
          tabindex: "tabindex",
          placeholder: "placeholder",
          filterPlaceholder: "filterPlaceholder",
          inputId: "inputId",
          selectId: "selectId",
          dataKey: "dataKey",
          filterBy: "filterBy",
          autofocus: "autofocus",
          resetFilterOnHide: "resetFilterOnHide",
          dropdownIcon: "dropdownIcon",
          optionLabel: "optionLabel",
          autoDisplayFirst: "autoDisplayFirst",
          group: "group",
          showClear: "showClear",
          emptyFilterMessage: "emptyFilterMessage",
          virtualScroll: "virtualScroll",
          virtualScrollItemSize: "virtualScrollItemSize",
          autoZIndex: "autoZIndex",
          baseZIndex: "baseZIndex",
          showTransitionOptions: "showTransitionOptions",
          hideTransitionOptions: "hideTransitionOptions",
          ariaFilterLabel: "ariaFilterLabel",
          withImages: "withImages",
          disabled: "disabled",
          customLabelProperty: "customLabelProperty",
          openOnFocus: "openOnFocus",
          hasTooltip: "hasTooltip",
          optionValue: "optionValue",
          autofocusFilter: "autofocusFilter",
          floatLabel: "floatLabel",
          withIcons: "withIcons"
        },
        outputs: {
          change: "change",
          changeSelection: "changeSelection",
          focus: "focus",
          blur: "blur",
          click: "click",
          show: "show",
          hide: "hide"
        },
        features: [i0.ɵɵProvidersFeature([ValueAccessorBase.getProviderConfig(CapturumDropdownComponent)]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c5,
        decls: 16,
        vars: 4,
        consts: [[1, "form-element"], [3, "style", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["floatingInput", ""], ["defaultTemplate", ""], ["selectedItemWithImages", ""], ["selectedItemWithIcon", ""], ["itemWithImages", ""], ["itemWithIcon", ""], [3, "control", "customName", 4, "ngIf"], [4, "ngIf"], [4, "ngTemplateOutlet"], [1, "p-float-label", "dropdown-float-label"], ["htmlFor", "float-label", 1, "cpb-float-label"], [3, "ngModel", "appendTo", "filterBy", "filterPlaceholder", "autoDisplayFirst", "filter", "optionLabel", "options", "panelStyleClass", "panelStyle", "editable", "placeholder", "scrollHeight", "resetFilterOnHide", "showClear", "group", "styleClass", "virtualScroll", "virtualScrollItemSize", "disabled", "dropdownIcon", "readonly", "optionValue", "tabindex", "autofocus", "autofocusFilter", "onChange", "onBlur", "onFocus", "onClick", "onHide", "onShow", "focus", "ngModelChange"], ["pTemplate", "item"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["pTemplate", "selectedItem"], [1, "selected-item-container"], [1, "selected-img", 3, "src"], [1, "selected-label"], [3, "ngClass"], [1, "selected-label-icon"], [1, "custom-item"], [1, "custom-img", 3, "src"], [1, "custom-label"], [1, "cap-dropdown-item-with-icon"], [1, "cap-dropdown-item-with-icon-label"], [3, "control", "customName"]],
        template: function CapturumDropdownComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c4);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, CapturumDropdownComponent_label_1_Template, 3, 5, "label", 1);
            i0.ɵɵtemplate(2, CapturumDropdownComponent_ng_container_2_Template, 2, 1, "ng-container", 2);
            i0.ɵɵtemplate(3, CapturumDropdownComponent_ng_template_3_Template, 4, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(5, CapturumDropdownComponent_ng_template_5_Template, 4, 33, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(7, CapturumDropdownComponent_ng_template_7_Template, 4, 2, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(9, CapturumDropdownComponent_ng_template_9_Template, 4, 4, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(11, CapturumDropdownComponent_ng_template_11_Template, 4, 2, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(13, CapturumDropdownComponent_ng_template_13_Template, 4, 4, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(15, CapturumDropdownComponent_cap_validator_15_Template, 1, 2, "cap-validator", 9);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const _r2 = i0.ɵɵreference(4);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (ctx.label || ctx.hasTooltip) && !ctx.floatLabel);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.floatLabel)("ngIfElse", _r2);
            i0.ɵɵadvance(13);
            i0.ɵɵproperty("ngIf", ctx.control);
          }
        },
        dependencies: [i2.NgClass, i2.NgIf, i2.NgTemplateOutlet, i3.NgControlStatus, i3.NgModel, i4.Dropdown, i5.PrimeTemplate, i1.CapturumValidatorComponent],
        encapsulation: 2
      });
    }
  }
  return CapturumDropdownComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumDropdownModule = /*#__PURE__*/(() => {
  class CapturumDropdownModule {
    static {
      this.ɵfac = function CapturumDropdownModule_Factory(t) {
        return new (t || CapturumDropdownModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CapturumDropdownModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, DropdownModule, CapturumSharedModule, OverlayPanelModule]
      });
    }
  }
  return CapturumDropdownModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CapturumDropdownComponent, CapturumDropdownModule };
